/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function() {
    const loader = document.querySelector("#products-loader") || "";
    var endlessScroll = new Ajaxinate({
        container: '#ProductsLoop',
        pagination: '#ProductsPagination',
        loadingText: loader.innerHTML
      });
  });

  document.addEventListener("DOMContentLoaded", function () {
    var maxLength = 300;
    var showReadMoreElements = document.querySelectorAll(".show-read-more");
    var lbl_read_More = document.querySelector(".show-read-more")?.getAttribute("data-lbl-read-more") ;

    showReadMoreElements.forEach(function (element) {
        var myStr = element.textContent;

        if (myStr.trim().length > maxLength) {
            var newStr = myStr.substring(0, maxLength);
            var removedStr = myStr.substring(maxLength, myStr.trim().length);

            element.innerHTML = newStr;
            element.innerHTML += ' <a href="javascript:void(0);" class="read-more">'+ lbl_read_More +'...</a>';
            element.innerHTML += '<span class="more-text">' + removedStr + '</span>';
        }
    });

    var readMoreElements = document.querySelectorAll(".read-more");

    readMoreElements.forEach(function (element) {
        element.addEventListener("click", function () {
            var moreText = element.nextElementSibling;
            while (moreText.firstChild) {
                moreText.parentNode.insertBefore(moreText.firstChild, moreText);
            }
            moreText.remove();
            element.remove();
        });
    });
});

// Back to top

const backToTop = document.querySelector('[data-back-to-top]');

backToTop?.addEventListener("click", function(e){ 
    e.preventDefault()
    document.body.scrollIntoView({
        behavior: "smooth",
    });
});

//**************klaviyo back in stock button *****************//

// add error message when size not selected
const klaviyoButton = document.querySelector('.button-klaviyo');

if(klaviyoButton) {
    klaviyoButton.addEventListener('click', (event) => {
        let variantSelected = new URL(document.location).searchParams?.has('variant');
        let errMessage = document.querySelector('.select-size-err-msg');
        if(!variantSelected && errMessage && !klaviyoButton.hasAttribute('data-product-one-size')) {
            event.stopPropagation();
            errMessage.style.display = 'block';
        }
    });
}

// hide the error message when size is selected
document.addEventListener('variant:changed', function(event) {
    let errMessage = document.querySelector('.select-size-err-msg');
    errMessage && (errMessage.style.display = 'none');
});

//************************************************//

const isMobile = window.matchMedia('(max-width: 768px)').matches;

if(isMobile) {
    const accordionHeads = document.querySelectorAll('.footer__item-title--menu');
    accordionHeads?.forEach( accordionHead => {
        accordionHead.addEventListener('click', function () {
        const closeIcon = this.querySelector('.chevron');
        closeIcon?.classList.toggle('open');

        const accordionCollapse = this.nextElementSibling;
        if (accordionCollapse.style.maxHeight) {
            accordionCollapse.style.maxHeight = null;
            accordionCollapse.classList.remove('open')

        } else {
            accordionCollapse.style.maxHeight = accordionCollapse.scrollHeight + 'px';
            accordionCollapse.classList.add('open')

        }
        });
    });
}

/**** Change nosto section width depending on the cart content width**************/
if(window.themeVariables.settings.pageType.toLowerCase().includes("cart") && document.querySelector('#cross-selling-cart')) {
    function changeNostoCartWidth() {
        document.documentElement.style.setProperty('--first-column-width', document.querySelector('.cart__content').offsetWidth + 'px');
    }
    window.addEventListener('resize', changeNostoCartWidth);
    changeNostoCartWidth();
}

/**** open icon media ****/

document.addEventListener("DOMContentLoaded", function() {
    const linkFolowUs = document.querySelector(".link--folow__us");
    const blockIconMedia = document.querySelector(".link--folow__us .link--folow__us_blocks");
    const footerItemTitleMenu = document.querySelector(".footer__item-title--menu");
    let iconsVisible = false;

    linkFolowUs.addEventListener("click", function() {
        if (iconsVisible) {
            blockIconMedia.style.display = "none";
        } else {
            blockIconMedia.style.display = "flex";
        }
        iconsVisible = !iconsVisible;
    });

    if(isMobile) {
        footerItemTitleMenu.addEventListener("click",function(){
            blockIconMedia.style.display = "none"
        })

        let iconsVisible = false;
        
        linkFolowUs.addEventListener("click", function() {
            if (iconsVisible) {
                blockIconMedia.style.visibility = "hidden";
            } else {
                blockIconMedia.style.visibility = "visible";
            }
            iconsVisible = !iconsVisible;
        });
    }
});

/**** when i open a second category close first categorie ****/

document.addEventListener('DOMContentLoaded', function() {
    var buttons = document.querySelectorAll('.mobile-nav__item button');

    buttons.forEach(function(button) {
        button.addEventListener('click', function() {
            closeAllCollapsibles();

            var collapsibleId = button.getAttribute('aria-controls');
            
            var buttonLevel = parseInt(button.closest('.mobile-nav__item').getAttribute('data-level'));

            var collapsible = document.getElementById(collapsibleId);
            if (collapsible) {
                collapsible.setAttribute('aria-expanded', 'true');
            }

            if (buttonLevel === 1) {
                var levelOneButtons = document.querySelectorAll('.mobile-nav__item[data-level="1"] button');
                levelOneButtons.forEach(function(levelOneButton) {
                    if (levelOneButton !== button) {
                        levelOneButton.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        });
    });

    function closeAllCollapsibles() {
        var collapsibles = document.querySelectorAll('.collapsible');
        collapsibles.forEach(function(collapsible) {
            collapsible.setAttribute('aria-expanded', 'false');
        });
    }
});